import { Stack } from 'expo-router';
import { BelieveMakePaymentProvider } from 'features/believe/makePayment/provider/BelieveMakePaymentProvider';
import React from 'react';

export default function BelieveLayout() {
  return (
    <BelieveMakePaymentProvider>
      <Stack />
    </BelieveMakePaymentProvider>
  );
}
